import type { HttpTransport } from "@common/api/transport";
import type { ID } from "@common/types/api";

export const createPlantingsApi = (http: HttpTransport) => ({
  addSuccessionPlanting: (id: ID) =>
    fetch(`/api/plantings/${id}/add_succession`, { method: "PATCH" }),

  addSuccessionPlantingWarning: (id: number): Promise<{ warning?: string }> =>
    http.patch(`/api/plantings/${id}/add_succession_warning`, {}),

  destroyPlanting: (id: ID) => fetch(`/api/plantings/${id}`, { method: "DELETE" }),

  duplicatePlanting: (id: ID) =>
    fetch(`/api/plantings/${id}/duplicate`, { method: "PATCH" }),

  fetchVisiblePlantings: () =>
    http.get<{ visiblePlantings: number[] }>("/api/plantings/visible"),

  linkPlantingCrop: (id: ID) => fetch(`/api/plantings/${id}/link`, { method: "PATCH" }),

  togglePlanting: (id: ID) =>
    http.patch<{ isVisible: boolean }>(`/api/plantings/${id}/toggle`, {})
});
